module.exports = __webpack_public_path__ + "static/media/screenshot5.3c2e7302.png";